import { type TabType } from '@/hooks/query/useQuerySessionWindows';
import { isTauri } from '@/tauri/utils';
import {
  Brain,
  DateFormat,
  LanguageCode,
  TemplateCategory,
  VoiceStyle,
} from '@heidi/schema/ml-scribe';

export const DEFAULT_VOICE_STYLE = VoiceStyle.GOLDILOCKS;
export const DEFAULT_BRAIN = Brain.LEFT;
export const DEFAULT_DEBOUNCE_TIME = 100;
export const DEFAULT_DEBOUNCE_MAX_WAIT = 300;
export const RECORDING_DEBOUNCE_TIME = isTauri() ? 1000 : 1000;
export const UPLOAD_FILE_DISABLED_LANGUAGE_CODES = [LanguageCode.auto, null];
export const TEMPLATE_CATEGORY_ONLY_NOTE_DOCUMENT = Object.values(
  TemplateCategory
).filter(
  (category) =>
    category === TemplateCategory.DOCUMENT_TEMPLATE ||
    category === TemplateCategory.CONSULT_NOTE_TEMPLATE ||
    category === TemplateCategory.PRECHART_TEMPLATE
);

export type DictationSource = TabType | 'askAi' | 'createTemplate';

export const DEFAULT_DATE_FORMAT = DateFormat.DAY_MONTH_YEAR;

export const DEFAULT_DATETIME_FORMAT = 'MM/dd h:mmaaa';
export const FILENAME_SAFE_DATETIME_FORMAT = 'MM-dd hh-mma';

export const MAX_LANGUAGE_SELECTIONS = 3;

export const OAUTH_TIMEOUT_MS = 60000;
